import React from 'react';
import PropTypes from 'prop-types';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(err) {
    this.props.errorCallback && this.props.errorCallback(err);
    // Can be used to log error to an error reporting service
    // eg: logErrorToMyService(error, errorInfo);
  }

  render() {
    const {
      fallback,
      children
    } = this.props;
    const {
      hasError,
      error
    } = this.state;
    if (hasError) {
      return fallback ? fallback(error) : 'Something went wrong!';
    }
    return children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  errorCallback: PropTypes.func
};
export { ErrorBoundary };